import React, { useState } from "react";
import { pointsConfig } from "../../../pointsConfig";
import IntraverseRanksModal from "../../modal/milesPoints/IntraverseRanksModal";
import CurrentRankModal from "../../modal/milesPoints/CurrentRankModal";
import BadgeEarnedModal from "../../modal/milesPoints/BadgeEarnedModal";
import WheelSpinningModal from "../../modal/milesPoints/WheelSpinningModal";
import CurrentRankProgressModal from "../../modal/milesPoints/CurrentRankProgressModal";
import { useLocation, useNavigate } from "react-router-dom";
import { URLdecode, URLencode } from "../../../utils/url";

function MilesPointsDashboardHeader() {
  const params = URLdecode();
  const navigate = useNavigate();
  const [ranksModal, setRanksModal] = useState(false);
  const [currentModal, setCurrentModal] = useState(false);

  const handleViewLeaderboard = () => {
    navigate(
      `/milesPoints?${URLencode({
        ...params,
        tab: pointsConfig.tabs.leaderboard.code,
      })}`
    );
  };

  return (
    <div className="p-4 w-full bg-[#F5F5F5] justify-between flex items-center">
      {/* <IntraverseRanksModal open={ranksModal} setOpen={setRanksModal} /> */}
      <CurrentRankProgressModal open={ranksModal} setOpen={setRanksModal} />
      {/* <CurrentRankModal open={currentModal} setOpen={setCurrentModal} /> */}
      {/* <BadgeEarnedModal open={currentModal} setOpen={setCurrentModal} /> */}
      <WheelSpinningModal open={currentModal} setOpen={setCurrentModal} />
      <div className="flex gap-2 items-center">
        <button onClick={() => setRanksModal(true)}>
          <img
            src={pointsConfig.ranks.master.icon}
            alt=""
            className="w-24 h-24 object-contain"
          />
        </button>
        <div
          className="flex flex-col cursor-pointer"
          onClick={() => setCurrentModal(true)}
        >
          <span className="font-black text-3xl">9th</span>
          <span className="font-bold">
            {pointsConfig.ranks.master.label}: 2,400pts
          </span>
        </div>
      </div>
      <button
        className="px-4 py-1 rounded-md text-sm font-bold bg-black text-white"
        onClick={() => handleViewLeaderboard()}
      >
        View leaderboard
      </button>
    </div>
  );
}

export default MilesPointsDashboardHeader;
